
// import './App.css';
import './Scripts/Styles/App_Stylesheet_Base.css';
// import './ERUMAUI/Stylesheet_ERUMAUI_Reference.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectRoute from './components/ProtectRoute'
import AuthProvider from './Contexts/AuthContext';
import DRLogin from './pages/DR_Login'
import DRMain from './pages/DR_Main'
import DR_Verify from './pages/DR_Verify';
import DR_ResetPassword from './pages/DR_ResetPassword';
import DR_ResetPassword_Final from './pages/DR_ResetPassword_Final';
import DR_Reports from './pages/DR_Reports';
import DR_Test from './pages/DR_Test';
import OverlayPrototype from './components/Overlay_Prototype'
import Overlay_Header_Account from './components/Overlay_Header_Account';
import Overlay_Errors from './components/Overlay_Errors';
import DR_Splash from './Assets/Images/NSDAPS_Main_Facade.png'
import DR_RED from './Assets/Images/RED_Logo.png'
import DR_Logo from './Assets/Images/DR_Logo.png'
// import CONTEXT_PROVIDER_APP_PROPERTIES from './Contexts/Context_App_Properties';
import UI_LoadingScreen from './components/ERUMAUI/UI_LoadingScreen';
import { Provider_UI } from './Contexts/Context_UI';
import DR_MapEditor from './pages/DR_MapEditor';
import DR_Status from './pages/DR_Status';
import DR_User from './pages/DR_User';
import DR_ScheduleManagement_Manager from './pages/DR_ScheduleManagement_Manager'
import { useEffect, useState } from 'react';
import Context_Provider_Status_Global from './Contexts/Context_Status_Global';
import Context_Provider_Templating from './Contexts/Context_Templating';
import Context_Provider_MapRenderer from './Contexts/Context_MapRenderer';
import Context_Provider_Accounts from './Contexts/Context_Accounts';
import Context_Provider_ScheduleManagement from './Contexts/Context_ScheduleManagement';
import Context_Provider_Reporting from './Contexts/Context_Reporter';
import Context_Provider_Progressor from './Contexts/Context_Progressor';

import Page_Entry from './DR2/Entry/Page_Entry';
// import UI_LoadingScreen from './DR2/ERUMAUI/UI_LoadingScreen';
// import { Provider_ERUMAUI } from './DR2/ERUMAUI/Context_ERUMAUI';


function App_Wrapper() {
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("DR_Mode"))?.Mode == "Dark") {
      document.getElementById("body").setAttribute("Theme", "Dark");
    } else {
      document.getElementById("body").setAttribute("Theme", "Light");
    }
  })

  return (
    <Router>
      <AuthProvider>
        <Provider_UI>
          {/* <Provider_ERUMAUI> */}
            <div className='App'>
              <UI_LoadingScreen id="Screen_Loading" Type="Splash" Text="Loading page. Please wait..." />
              <div className='Overlays'>
                <OverlayPrototype />
                <Overlay_Header_Account />
                <Overlay_Errors />
                <div className='Toasts' id='Toasts' Position="Right"></div>
              </div>

              <Context_Provider_Status_Global>
                <Context_Provider_Progressor>
                  <Context_Provider_Templating>
                    <Context_Provider_Accounts>
                      <Context_Provider_MapRenderer>
                        <Context_Provider_ScheduleManagement>
                          <Context_Provider_Reporting>
                            <Routes>
                              <Route path='/' element={<DRLogin />} />
                              <Route path='/DR2/Entry' element={<Page_Entry />} />
                              <Route path='/verify' element={<DR_Verify />} />
                              <Route path='/resetpassword' element={<DR_ResetPassword />} />
                              <Route path='/resetpassword_2' element={<DR_ResetPassword_Final />} />
                              <Route path='/test' element={
                                <ProtectRoute>
                                  <DR_Test />
                                </ProtectRoute>
                              } />
                              <Route path='/test/home' element={
                                <ProtectRoute>
                                  <DR_Test />
                                </ProtectRoute>
                              } />
                              <Route path='/test/home/test' element={
                                <ProtectRoute>
                                  <DR_Test />
                                </ProtectRoute>
                              } />
                              <Route path='/test/map' element={
                                <ProtectRoute>
                                  <DR_Test />
                                </ProtectRoute>
                              } />
                              <Route path='/main' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/home' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/map' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/schedules' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/schedules/reserve' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/reports' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/accounts' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/templating' element={
                                <ProtectRoute>
                                  <DRMain />
                                </ProtectRoute>
                              } />
                              <Route path='/map/edit' element={
                                <ProtectRoute>
                                  <DR_MapEditor />
                                </ProtectRoute>
                              } />
                              <Route path='/map/edit/add/building' element={
                                <ProtectRoute>
                                  <DR_MapEditor />
                                </ProtectRoute>
                              } />
                              <Route path='/map/edit/add/floor' element={
                                <ProtectRoute>
                                  <DR_MapEditor />
                                </ProtectRoute>
                              } />
                              <Route path='/map/edit/add/room' element={
                                <ProtectRoute>
                                  <DR_MapEditor />
                                </ProtectRoute>
                              } />
                              <Route path='/map/edit/table' element={
                                <ProtectRoute>
                                  <DR_MapEditor />
                                </ProtectRoute>
                              } />
                              <Route path='/map/edit/bin' element={
                                <ProtectRoute>
                                  <DR_MapEditor />
                                </ProtectRoute>
                              } />
                              <Route path='/status' element={
                                <ProtectRoute>
                                  <DR_Status />
                                </ProtectRoute>
                              } />
                              <Route path='/schedules/manage' element={
                                <ProtectRoute>
                                  <DR_ScheduleManagement_Manager />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/monthlysched' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/timetable' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/roomutil' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/floorutil' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/reservation' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/accounts' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/usertrail' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/reports/log' element={
                                <ProtectRoute>
                                  <DR_Reports />
                                </ProtectRoute>
                              } />
                              <Route path='/user' element={
                                <ProtectRoute>
                                  <DR_User />
                                </ProtectRoute>
                              } />
                              <Route path='/user/edit' element={
                                <ProtectRoute>
                                  <DR_User />
                                </ProtectRoute>
                              } />
                            </Routes>
                          </Context_Provider_Reporting>
                        </Context_Provider_ScheduleManagement>
                      </Context_Provider_MapRenderer>
                    </Context_Provider_Accounts>
                  </Context_Provider_Templating>
                </Context_Provider_Progressor>
              </Context_Provider_Status_Global>


            </div>
          {/* </Provider_ERUMAUI> */}
        </Provider_UI>
      </AuthProvider>
    </Router>

  );
}

export default App_Wrapper;
